"use client";

import { Layout, Button, Menu } from "antd";
import { ApartmentOutlined, LogoutOutlined } from "@ant-design/icons";
import { usePathname, useRouter } from "next/navigation";
import type { ReactNode } from "react";
import { useAuth } from "@/auth/AuthContext";
import styles from "./shell.module.css";

const { Sider, Content } = Layout;

export function AppShell({ children }: { children: ReactNode }) {
  const pathname = usePathname();
  const router = useRouter();
  const { username, logout } = useAuth();
  const selected = pathname === "/" || pathname.startsWith("/vendors") ? ["vendors"] : [];

  return (
    <Layout className={styles.shell}>
      <Sider className={styles.sider} theme="light" width={232}>
        <div className={styles.siderInner}>
          <div className={styles.brand}>
            <p className={styles.brandName}>Audience</p>
            <p className={styles.brandMeta}>Vendor catalog</p>
          </div>
          <Menu
            mode="inline"
            selectedKeys={selected}
            style={{ borderInlineEnd: "none" }}
            items={[
              {
                key: "vendors",
                icon: <ApartmentOutlined />,
                label: "Vendors",
              },
            ]}
            onClick={({ key }) => {
              if (key === "vendors") router.push("/");
            }}
          />
          <div className={styles.footer}>
            {username ? <p className={styles.signedIn}>{username}</p> : null}
            <Button type="text" icon={<LogoutOutlined />} onClick={() => void logout()} block>
              Log out
            </Button>
          </div>
        </div>
      </Sider>
      <Content className={styles.content}>
        <div className={styles.frame}>{children}</div>
      </Content>
    </Layout>
  );
}
